import axios from 'axios';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

const apiPath = `${store.state.apiPathWithVersion}/session`;

// In-flight dedupe: si una llamada a check() está en curso, los siguientes
// invocadores reciben la misma Promise en vez de disparar otra HTTP.
let inflight = null;

export default {
  async check(updateAnalytics) {
    if (inflight) {
      return inflight;
    }

    inflight = (async () => {
      let apiUrl = store.state.countrySelected.api;
      try {
        let resp = await axios.get(`${apiUrl}/${apiPath}/check`);
        store.commit('UPDATE_USER', resp.data);

        if (updateAnalytics) {
          EventBus.$emit(keys.updateUserData);
        }

        return {
          data: resp.data,
          error: false
        };
      } catch (error) {
        return {
          data: error.data,
          error: true
        };
      } finally {
        inflight = null;
      }
    })();

    return inflight;
  }
};
